/**
 * Module-level switch to disable recharts enter animations while the full-page
 * PDF export renders its off-screen copy of the results. Animated shapes draw
 * via requestAnimationFrame, which Chrome freezes for occluded windows — so a
 * capture taken while the window is covered/minimized would get empty charts.
 * (recharts' Global.isSsr can't be used here: it is snapshotted into
 * defaultProps when the chart modules first load.)
 */
let chartAnimationsDisabled = false;

export const setChartAnimationsDisabled = (disabled: boolean): void => {
  chartAnimationsDisabled = disabled;
};

export const areChartAnimationsDisabled = (): boolean => chartAnimationsDisabled;
